import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class HudView extends AbstractView {

    constructor(target, languagePack) {
        super(target);
        this._languagePack = languagePack;
        this._scoreTextfield = this._target.scoreTextfield;
        this._mistakesTextfield = this._target.mistakesTextfield;
        this._timeTextfield = this._target.timeTextfield;

        this._target.mistakesLabelTextfield.lineWidth = null;
        this._target.scoreLabelTextfield.lineWidth = null;
        this._target.timeLabelTextfield.lineWidth = null;
        
        this._target.mistakesLabelTextfield.text = this.getText("hud.mistakesLabel");
        this._target.scoreLabelTextfield.text = this.getText("hud.scoreLabel");
        this._target.timeLabelTextfield.text = this.getText("hud.timeLabel");
    }

    /**
     * @param {Number} value - remaining time in msecs
     */
    setTime(value) {
        value = Math.max(value, 0);
        const secs = Math.floor(value / 1000) % 60;
        const mins = Math.floor(value / 60000) % 60;
        const hours = Math.floor(value / 3600000) % 24;
        let str = padTime(mins) + ":" + padTime(secs);
        if (hours > 0) {
            str = hours + ":" + str;
        }
        this._timeTextfield.text = str;
    }

    setMistakes(n) {
        this._mistakesTextfield.text = n;
    }

    setScore(n) {
        this._scoreTextfield.text = n;
    }
}


function padTime(str) {
    return ("0" + str).substr(-2);
}